import { useEffect } from 'react';
import * as actions from 'actions';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import useRequest from "hooks/useRequest";
import {LANGUAGE} from "config/const";

const useProject = () => {
    const request = useRequest();
    const dispatch = useDispatch();
    const {name} = useParams();
    const projects = useSelector(state => state.projects);
    const project = useSelector(state => state.project);

    const fetchProjectList=async ()=> {
        // リスト取得
        let res = await request.post('project/list');
        dispatch(actions.fetchProjects(res.projects || []));
    };

    const fetchProject=async ()=> {
        if(!name) return ;

        if(project.name && project.name === name) {
            return ;
        }
        let res = await request.post('project/get', {name});
        if(!res.project.languageCode) {
            res.project.languageCode = LANGUAGE.CODE.JAPANESE;
        }
        dispatch(actions.findProject(res.project));
    };

    const create = async (project) => {
        let res = await request.post('project/create', {...project});
        dispatch(actions.addProject(res.project));
        await fetchProjectList();
    };

    const edit = async (project) => {
        let res = await request.post('project/update', {...project});
        dispatch(actions.editProject(res.project));
    };

    const remove = async (project) => {
        await request.post('project/delete', {...project});
    };

    useEffect(()=> {
        console.log('fetchProject')
        fetchProject();
        // fetchProjectList();
    }, [projects.length]);

    return {projects, project, create, edit, remove, fetchProjectList, fetchProject};
};

export default useProject;
